import { render } from "./DumplingView.vue?vue&type=template&id=4056376e"
import script from "./DumplingView.vue?vue&type=script&lang=js"
export * from "./DumplingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__